import styled from 'styled-components'
import { Button } from "@mui/material";

export const ProceedBtn = styled(Button)`
    // margin-top: 10px !important;
    width: 100% !important;
    padding: 10px 20px !important;
    background: #3150A1 !important;
    color: white !important;
    dispaly: flex;
    gap: 10px;
    opacity: ${(props: any): any => props.disabled ? '0.9' : '1'};
`;

export const CancelBtn = styled(Button)`
    margin: 10px !important;
    padding: 10px 20px !important;
    background: none !important;
    color: #EB5757 !important;
`;

export const AddLookUpBtn = styled(Button)`
    display: flex !important;
    padding: 4px 8px !important;
    color: white !important;
    background: #3150A1 !important;
    justify-content: space-between !important;
    align-items: center !important;
    gap: 5px !important;
    text-transform: capitalize !important;
    margin-right: 10px !important;
`;
